<template>
  <div class="product" @click="showProductDetail(product)">
    <div class="card-image-top">
      <img v-if="product.cover" :src="product.cover" alt="" />
      <img v-else src="@/assets/img/pexels-photo-106399.jpeg" alt="" />
      <div
        class="available-status"
        :class="product.is_available == 1 ? '' : 'order'"
      >
        <img src="@/assets/icons/bag-2.svg" alt="" />
        <span v-if="product.is_available == 1">Hàng có sẵn</span>
        <span v-else @click="filterUnavailableProducts()">Hàng order</span>
      </div>
    </div>
    <div class="card-body">
      <p class="name">{{ product.name }}</p>
      <div class="price">
        <span>Giá: </span>
        <span v-if="product.price">{{ product.price }} VND</span>
        <span v-else>Liên hệ</span>
      </div>
      <div class="brand" @click.stop="filterByBrandName(product.branch_name)">
        <img src="@/assets/img/chanel.png" alt="" />
        <span>{{ product.branch_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("publicStoreModule");
export default {
  props: {
    product: Object,
  },
  methods: {
    ...mapActions(["getProduct"]),
    showProductDetail(product) {
      this.$router.push({
        name: "front.product.detail",
        params: { id: product.id },
      });
      this.getProduct(this.product.id);
    },
    filterByBrandName(name) {
      alert(name)
    },
    filterUnavailableProducts() {
      alert('Hàng order mới có')
    }
  },
};
</script>

<style scoped lang="scss">
.product {
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
  cursor: pointer;
  .card-image-top {
    width: 100%;
    height: 266px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: 0.2s ease-in;
      &:hover {
        transform: scale(1.1);
      }
    }
    .available-status {
      position: absolute;
      bottom: 22px;
      left: 19px;
      padding: 7px;
      border-radius: 100px;
      width: 142px;
      background-color: #8f8f8f;
      text-transform: uppercase;
      display: flex;
      align-items: center;
      color: #fff;
      font-size: 12px;
      img {
        height: 20px;
        width: auto;
        margin-right: 8px;
      }
      &.order {
        background-color: rgb(8, 175, 44);
        color: #fff;
      }
      span {
        line-height: 20px;
        transform: translateY(3px);
      }
    }
  }
  .card-body {
    padding: 30px 20px;
    p {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      margin-bottom: 25px;
      color: #000;
    }
    .price {
      margin-bottom: 25px;
      span {
        font-size: 14px;
      }
      span:nth-child(1) {
        display: inline-block;
        margin-right: 15px;
      }
      span:nth-child(2) {
        color: rgb(241, 143, 143);
      }
    }
    .brand {
      display: flex;
      align-items: center;
      img {
        height: 24px;
        width: auto;
        margin-right: 10px;
      }
      span {
        color: #000;
        font-weight: bold;
      }
    }
  }
}
</style>
